/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';

import { StyledWrapper } from './styled';
import { type SkeletonProps } from './types';

const defaultDimensions = {
	line: [24, 1.5],
	circle: [3, 3],
	square: [3, 3],
};

const Skeleton = ({ width, height, variant = 'line' }: SkeletonProps) => (
	<StyledWrapper
		variant={variant}
		dimensions={{
			width: width ?? defaultDimensions[variant][0],
			height: height ?? defaultDimensions[variant][1],
		}}
		data-testid="eoc-skeleton"
	/>
);

export default Skeleton;
